import { render, staticRenderFns } from "./AdminCourse.vue?vue&type=template&id=9ec931dc"
import script from "./AdminCourse.vue?vue&type=script&lang=js"
export * from "./AdminCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports